import { useState } from "react";
import { Loader2, Save, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LetterForm = ({ initial = {}, onClose, onSaved }) => {
  const [loading, setLoading] = useState(false);
  const [letter, setLetter] = useState({
    patient_name: initial.patient_name || "",
    patient_email: initial.patient_email || "",
    title: "",
    content: "",
    month: "",
  });
  const set = (field) => (e) => setLetter({ ...letter, [field]: e.target.value });
  const inputClass = "w-full px-4 py-3 rounded-xl border border-stone-200 focus:outline-none focus:ring-2 focus:ring-[#2c4c3b]/20";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/letters`, letter, { withCredentials: true });
      toast.success("Lettera creata con successo!");
      onSaved();
    } catch (err) {
      toast.error("Errore nella creazione della lettera");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl p-8 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-serif text-2xl text-stone-900">Nuova Lettera</h2>
          <button onClick={onClose} className="p-2 hover:bg-stone-100 rounded-full">
            <X className="w-5 h-5 text-stone-500" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-stone-600 mb-2">Nome Paziente *</label>
              <input type="text" value={letter.patient_name} onChange={set("patient_name")} required className={inputClass} placeholder="Maria Rossi" data-testid="letter-patient-name" />
            </div>
            <div>
              <label className="block text-sm text-stone-600 mb-2">Email Paziente *</label>
              <input type="email" value={letter.patient_email} onChange={set("patient_email")} required className={inputClass} placeholder="maria@email.com" data-testid="letter-patient-email" />
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-stone-600 mb-2">Titolo Lettera *</label>
              <input type="text" value={letter.title} onChange={set("title")} required className={inputClass} placeholder="Il Linguaggio del Tuo Corpo" data-testid="letter-title" />
            </div>
            <div>
              <label className="block text-sm text-stone-600 mb-2">Mese *</label>
              <input type="text" value={letter.month} onChange={set("month")} required className={inputClass} placeholder="Giugno 2026" data-testid="letter-month" />
            </div>
          </div>
          <div>
            <label className="block text-sm text-stone-600 mb-2">Contenuto Lettera *</label>
            <textarea value={letter.content} onChange={set("content")} required className={`${inputClass} min-h-[250px] resize-none`} data-testid="letter-content" />
          </div>
          <div className="flex gap-4 pt-4">
            <Button type="button" variant="outline" onClick={onClose} className="flex-1 rounded-full py-6">Annulla</Button>
            <Button type="submit" disabled={loading} className="flex-1 bg-[#2c4c3b] hover:bg-[#1a2e22] text-stone-50 rounded-full py-6" data-testid="save-letter-btn">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : (<><Save className="w-4 h-4 mr-2" />Salva Lettera</>)}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LetterForm;
